import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ChatManagerInstance from "./ChatManager";
import BaseSession from "./BaseSession";
import FirebaseConversationSession from "./FirebaseConversationSession";
import * as log from "loglevel";

var ConversationSession = /*#__PURE__*/function (_BaseSession) {
  _inherits(ConversationSession, _BaseSession);

  function ConversationSession(userName, conversationName, accessToken) {
    var _this;

    _classCallCheck(this, ConversationSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConversationSession).call(this, userName, accessToken));
    _this.conversationName = conversationName.toLowerCase();
    _this.audioFile = null;
    _this.resourceName = null;
    return _this;
  }

  _createClass(ConversationSession, [{
    key: "getAPIRequestFirebaseAccessURL",
    value: function getAPIRequestFirebaseAccessURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/access?username=" + this.userName;
    }
  }, {
    key: "buildFirebaseSession",
    value: function buildFirebaseSession() {
      return new FirebaseConversationSession(this.userName, this.conversationName, this._id);
    }
  }, {
    key: "getAPIConversationsURL",
    value: function getAPIConversationsURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;
    }
  }, {
    key: "getAPIMessagesURL",
    value: function getAPIMessagesURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/messages";
    }
  }, {
    key: "getApiResourceURL",
    value: function getApiResourceURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/resources";
    }
  }, {
    key: "writeMessage",
    value: function writeMessage(message) {
      this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
        message: message,
        type: "TEXT"
      });
    }
  }, {
    key: "writeCustomMessage",
    value: function writeCustomMessage(details, message) {
      this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
        message: message,
        type: "CUSTOM",
        details: details
      });
    }
  }, {
    key: "editMessage",
    value: function editMessage(messageId, message, callback) {
      this.doAPIRequest(this.getAPIMessagesURL() + "/" + messageId, "PUT", {
        message: message,
        denyIfCensoredWords: false
      }, callback);
    }
  }, {
    key: "deleteMessage",
    value: function deleteMessage(messageId, callback) {
      this.doAPIRequest(this.getAPIMessagesURL() + "/" + messageId, "DELETE", {}, callback);
    }
  }, {
    key: "updateCustomField",
    value: function updateCustomField(object, updateCustomFieldHandler) {
      this.doAPIRequest(this.getAPIConversationsURL(), "PATCH", {
        custom: object
      }, updateCustomFieldHandler);
    }
  }, {
    key: "createResourceEntry",
    value: function createResourceEntry(audioFile, formatValue, createResourceEntryHandler) {
      var _this2 = this;

      this.doAxiosRequest(this.getApiResourceURL(), "POST", {
        format: formatValue
      }).then(function (response) {
        _this2.resourceName = response.data.name;
        return _this2.uploadResourceRequest(response.data.temporaryUrl, "PUT", audioFile);
      }).then(function (uploadResponse) {
        return _this2.doAxiosRequest(_this2.getApiResourceURL() + "/" + _this2.resourceName, "PUT", {
          "status": "UPLOADED"
        });
      }).then(function (completedResponse) {
        createResourceEntryHandler(null, {
          "resource": _this2.resourceName,
          "status": "UPLOADED"
        });
      }).catch(function (error) {
        createResourceEntryHandler(error);
      });
    }
  }, {
    key: "writeResourceMessage",
    value: function writeResourceMessage(resource, message, writeResourceMessageHandler, type) {
      this.doAPIRequest(this.getAPIMessagesURL(), "POST", {
        resource: resource,
        message: message,
        type: type
      }, writeResourceMessageHandler);
    }
  }, {
    key: "getResourceDetails",
    value: function getResourceDetails(resource, getResourceDetailsHandler, abortSignal) {
      this.doGETRequest(this.getApiResourceURL() + "/" + resource, getResourceDetailsHandler, abortSignal);
    }
  }, {
    key: "getAPILastReadTimestampURL",
    value: function getAPILastReadTimestampURL() {
      return ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName + "/members/" + this.userName + "/lastReadTimestamp";
    }
  }, {
    key: "updateLastReadTimestamp",
    value: function updateLastReadTimestamp(timestamp) {
      this.doAPIRequest(this.getAPILastReadTimestampURL(), "PUT", {
        timestamp: timestamp
      });
    }
  }, {
    key: "getAPINextMessagesURL",
    value: function getAPINextMessagesURL(timestamp, page, size) {
      return this.getAPIMessagesHistoryURL("NEXT", timestamp, page, size);
    }
  }, {
    key: "getAPIAroundMessagesURL",
    value: function getAPIAroundMessagesURL(timestamp, beforeSize, afterSize) {
      var url = ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;
      url += "/aroundMessages?beforeSize=" + beforeSize + "&afterSize=" + afterSize + "&timestamp=" + timestamp;
      return url;
    }
  }, {
    key: "getAPIMessagesHistoryURL",
    value: function getAPIMessagesHistoryURL(type, timestamp, page, size) {
      var url = ChatManagerInstance.restApiURL + "/conversations/" + this.conversationName;

      if (type === "NEXT") {
        url += "/nextMessages?";
      } else if (type === "PREVIOUS") {
        url += "/previousMessages?";
      }

      if (timestamp !== void 0) {
        url += "timestamp=" + timestamp + "&";
      }

      if (page !== void 0) {
        url += "page=" + page + "&";
      }

      if (size !== void 0) {
        url += "size=" + size + "&";
      }

      return url;
    }
  }, {
    key: "getAroundMessages",
    value: function getAroundMessages(timestamp, beforeSize, afterSize, aroundMessagesHandler, abortSignal) {
      this.doGETRequest(this.getAPIAroundMessagesURL(timestamp, beforeSize, afterSize), aroundMessagesHandler, abortSignal);
    }
  }, {
    key: "getNextMessages",
    value: function getNextMessages(timestamp, page, size, nextMessagesHandler) {
      this.doGETRequest(this.getAPINextMessagesURL(timestamp, page, size), nextMessagesHandler);
    }
  }, {
    key: "getAPIPreviousMessagesURL",
    value: function getAPIPreviousMessagesURL(timestamp, page, size) {
      return this.getAPIMessagesHistoryURL("PREVIOUS", timestamp, page, size);
    }
  }, {
    key: "getPreviousMessages",
    value: function getPreviousMessages(timestamp, page, size, previousMessagesHandler) {
      this.doGETRequest(this.getAPIPreviousMessagesURL(timestamp, page, size), previousMessagesHandler);
    }
  }, {
    key: "setConversationListener",
    value: function setConversationListener(externalConversationEventsListener) {
      log.trace("attach external Conversationlistener");
      this.firebaseSession.attachConversationListener(function (conversationEvent) {
        log.trace("conversation event" + JSON.stringify(conversationEvent));
        externalConversationEventsListener(conversationEvent);
      });
    }
  }, {
    key: "leaveConversation",
    value: function leaveConversation() {
      this.firebaseSession.detachListener();
    }
  }]);

  return ConversationSession;
}(BaseSession);

export { ConversationSession as default };